import Echo from 'laravel-echo';

window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
  window.Popper = require('popper.js').default;
  window.$ = window.jQuery = require('jquery');

  require('bootstrap');

  window.moment = require('moment');

} catch (e) {}

window.Pusher = require('pusher-js');
Pusher.logToConsole = process.env.NODE_ENV === 'development' ? true : false;

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axiosInstance = axios.create({
  baseURL: process.env.MIX_APP_URL + '/api',
  validateStatus: function (status) {
    return status >= 200 && status <= 308;
  },
//  paramsSerializer: p => {
//    return qs.stringify(p, { arrayFormat: 'brackets' })
//  }
})

const token = localStorage.getItem('token') || false

if (token) {
  window.axiosInstance.defaults.headers.common.Authorization = 'Bearer ' + token
}

window.axiosInstance.defaults.headers.common['Accept'] = 'application/json'
window.axiosInstance.defaults.headers.common['Content-Language'] = (localStorage.getItem('language') || 'ro')
window.axiosInstance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.Echo = new Echo({
  authEndpoint: window.location.hostname + '/api/broadcasting/auth',
  broadcaster: 'pusher',
  key: process.env.MIX_PUSHER_APP_KEY,
  cluster: process.env.MIX_PUSHER_APP_CLUSTER,
  forceTLS: true,
  wsHost: window.location.hostname,
  wsPort: process.env.MIX_LARAVEL_WEBSOCKETS_PORT ?? 6001,
  wssPort: process.env.MIX_LARAVEL_WEBSOCKETS_PORT ?? 6001,
  enabledTransports: ['ws', 'wss'],
  logToConsole: process.env.NODE_ENV === 'development' ? true : false,
  auth: {
    headers: {
      'Authorization': 'Bearer ' + localStorage.getItem('token') || '',
    },
  },
  authorizer: (channel, options) => {
    return {
      authorize: (socketId, callback) => {
        console.log('auth')
        axiosInstance.post('/broadcasting/auth', {
            socket_id: socketId,
            channel_name: channel.name
          })
          .then(response => {
            callback(false, response.data);
          })
          .catch(error => {
            callback(true, error);
          })
      }
    }
  },
})

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });

window.urlBase64ToUint8Array = (base64String) => {
    var padding = '='.repeat((4 - base64String.length % 4) % 4);
    var base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');

    var rawData = window.atob(base64);
    var outputArray = new Uint8Array(rawData.length);

    for (var i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}
